import { Component } from 'vue-property-decorator'
import { Getter, State, Mutation, Action } from 'vuex-class'
import BasePage from '@/views/BasePage/BasePage'
import { configService } from '@/settings/api-url'
import Loading from '@/components/loading/loading'

@Component({
  components: {
    Loading
  }
})
export default class Login extends BasePage {

  @Action action_postResetPassword

  loading = false
  email = ''

  async _send () {
    try {
      this.loading = true
      await this.action_postResetPassword({ email: this.email })
      this.loading = false
      this.email = ''
      this.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        title: 'Información enviada al correo',
        timer: 3200
      })
    } catch (error) {
      this.loading = false
      this.$swal({
        title: 'Errror...',
        text: error.response.data.message,
        timer: 3200
      })
    }
  }

  _onClose () {
    localStorage.removeItem('_tc')
    // remove the axios default heade
    delete configService.defaults.headers.common['Authorization']
    this.$router.push({ name: 'login' })
  }

}
